import CloseIcon from '@mui/icons-material/Close';
import {
  AppBar,
  Box,
  Button,
  ButtonGroup,
  Checkbox,
  Dialog,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Slide,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Toolbar,
  Typography,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import React, { memo, useContext, useEffect, useState } from 'react';
import { getCsvData2, getSecretsList, testS3SecretConnection } from "../../../../api's/ConnectorsApi";
import { getCsvData } from "../../../../api's/RuleEngineApi";
import { WorkflowContext } from '../../../../contexts/WorkflowProvider';
import InputField from '../../../../reusable-component/InputField';
import LoadingIcon from '../../../../reusable-component/LoadingIcon';
import { populateNodeData } from '../../copilot/utils/CopilotUtils';
import { DATA_TYPE_READ } from '../../../../constants/Constant';
import useDebounce from '../../../../hooks/useDebounce';
import { AWS_CONFIG_TYPE } from '../../../../BaseUrl';
import { useS3WithPresignedUrls } from '../../auto-mapper-v2/hooks/useS3WithPreSignedUrls';


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const INITIALSTATE = {
  path: '',
  format: 'read_csv_aws',
  action: '',
  persist: false,
  connection_type: '',
  secret_name: '',
  alias: '',
  persist_type: '',
  database: '',
  delimiter: ',',
  tablename: '',
  ignoreblanklines: false,
  skipheaders: false,
  columnshift: false,
  junkrecords: false,
  linebreak: false,
  distinct_rows: false,
  clientId: '',
  clientName: '',
  batchName: '',
  tableNameRead: '',
  trackingId: '',
  innerPath: '',
  file: '',
  dataTypeRead: DATA_TYPE_READ,
  pathTypeFile: 'filepath',
  pagination: false,
  lowerBound: '',
  upperBound: '',
  CDC: false,
  partitionColumn: '',
  numPartitions: '',
  sample_view: true,
  priority: '',
};
const RowLevelOperation = {
  ignoreblanklines: false,
  skipheaders: false,
  columnshift: false,
  junkrecords: false,
  linebreak: false,
  delimiter: ',',
};

const NodeModalReadCSVAws = ({
  open,
  handleClose,
  nodeId,
  nodeName,
  nodes,
  edges,
  changeNodeName,
  setNodes,
  dataModel = false,
  dataModelformField,
  setDataModelformField = () => { },
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const { workflow, setPreviewData } = useContext(WorkflowContext);
  const { getSampleData } = useS3WithPresignedUrls();

  const src = dataModelformField?.source ?? {};

  const InitialData = dataModel
    ? {
      formField: src.formField ?? INITIALSTATE,
      headerName: src.headerName?.length ? src.headerName : [],
      fetchedHeader: src.fetchedHeader?.length ? src.fetchedHeader : [],
    }
    : {
      formField: INITIALSTATE,
      headerName: [],
      fetchedHeader: [],
    };

  const [formField, setFormField] = useState(InitialData.formField);
  const [disableForm, setDisableForm] = useState(false);
  const [headerName, setHeaderName] = useState(InitialData.headerName);
  const [fetchedHeader, setFetchedHeader] = useState(InitialData.fetchedHeader);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [isDataLoad, setisDataLoad] = useState(false);
  const [columns, setColumns] = useState([]);
  const [sampleRows, setSampleRows] = useState([]);
  const [tempHeader, setTempHeader] = useState([]);

  const [secretsList, setSecretsList] = useState([]);

  const [errors, setErrors] = useState({ train: '', test: '' });
  const [filePathTouched, setFilePathTouched] = useState(false);

  const debouncedFormField = useDebounce(formField, 200);

  useEffect(() => {
    if (!dataModel) return;

    const newSource = {
      nodeId,
      nodeName,
      formField: debouncedFormField,
      headerName,
      fetchedHeader,
      sampleMetaData: {
        columns,
        sampleRows,
      },
      step_name: nodeName,
    };
    const prevSource = dataModelformField?.source;

    if (
      JSON.stringify(prevSource?.formField) === JSON.stringify(newSource.formField) &&
      JSON.stringify(prevSource?.headerName) === JSON.stringify(newSource.headerName) &&
      JSON.stringify(prevSource?.fetchedHeader) === JSON.stringify(newSource.fetchedHeader) &&
      JSON.stringify(prevSource?.sampleMetaData) === JSON.stringify(newSource.sampleMetaData)
    ) {
      return;
    }

    setDataModelformField((prev) => ({
      ...prev,
      source: newSource,
    }));
  }, [debouncedFormField, headerName, fetchedHeader, dataModel, columns, sampleRows]);

  const handleHeaderChange = (obj) => {
    const selectedIndex = headerName.findIndex((object) => {
      return object.header === obj.header;
    });

    if (selectedIndex === -1 && obj.checked) {
      setHeaderName([...headerName, obj]);

      setFetchedHeader((current) =>
        current.map((object) => {
          if (object.header === obj.header) {
            return {
              header: obj.header,
              alias: obj.alias,
              checked: true,
              cast_datatype: obj.cast_datatype,
              attribute_type: obj.attribute_type,
              default_value: obj.default_value,
            };
          }

          return object;
        })
      );
    }

    if (selectedIndex !== -1 && obj.checked) {
      setHeaderName((current) =>
        current.map((object) => {
          if (object.header === obj.header) {
            return {
              ...object,
              header: obj.header,
              alias: obj.alias,
              cast_datatype: obj.cast_datatype,
              attribute_type: obj.attribute_type,
              default_value: obj.default_value,
            };
          }

          return object;
        })
      );

      setFetchedHeader((current) =>
        current.map((object) => {
          if (object.header === obj.header) {
            return {
              ...object,
              header: obj.header,
              alias: obj.alias,
              cast_datatype: obj.cast_datatype,
              attribute_type: obj.attribute_type,
              default_value: obj.default_value,
            };
          }

          return object;
        })
      );
    }

    if (selectedIndex !== -1 && !obj.checked) {
      setHeaderName((current) =>
        current.filter((object) => {
          return object.header !== obj.header;
        })
      );

      setFetchedHeader((current) =>
        current.map((object) => {
          if (object.header === obj.header) {
            return {
              ...object,
              checked: false,
              alias: '',
              cast_datatype: 'string',
              attribute_type: 'static',
              default_value: '',
            };
          }

          return object;
        })
      );
    }
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = fetchedHeader.map((n) => {
        const all = {
          header: n.header,
          alias: n.alias,
          checked: true,
          cast_datatype: 'string',
          attribute_type: 'static',
          default_value: '',
        };
        return all;
      });
      setHeaderName(newSelecteds);
      return;
    }
    setHeaderName([]);
  };

  const isSelected = (name) => {
    const selectedIndex = headerName.findIndex((object) => {
      return object.header === name;
    });

    return selectedIndex !== -1;
  };

  const store = JSON.parse(sessionStorage.getItem('allNodes'));

  const getLocalData = () => {
    if (store) {
      store.forEach((node) => {
        if (node.nodeId === nodeId) {
          setFormField(node.formField);
          setisDataLoad(true);
          setHeaderName(node.headerName);
          setTempHeader(node.headerName);
          setFetchedHeader(node.fetchedHeader);
          setColumns(node.sampleMetaData?.columns || []);
          setSampleRows(node.sampleMetaData?.sampleRows || []);
          if (node.disabled) {
            setDisableForm(node.disabled);
          }
          if (node.formField.connection_type === 'other' && node.formField.secret_name) {
            fetchSecrets();
          }
        }
      });
    }
  };

  const validate = () => {
    if (formField.pathTypeFile === 'filepath' && !formField.path.includes('.csv')) {
      setErrors({ ...errors, filepath: 'Enter valid file path' });
    } else if (formField.pathTypeFile === 'outputpath' && formField.path.includes('.csv')) {
      setErrors({ ...errors, outputpath: 'Enter valid folder path' });
    } else {
      setErrors({ filepath: '', outputpath: '' });
    }
  };

  useEffect(() => {
    validate();
  }, [formField.path, errors.filepath, errors.outputpath]);

  useEffect(() => {
    setFormField(InitialData.formField);
    setDisableForm(false);
    setFetchedHeader(InitialData.fetchedHeader);
    setHeaderName(InitialData.headerName);
    getLocalData();
  }, [nodeId]);

  let name, value;
  const handleInputChange = (e) => {
    name = e.target.name;
    if (
      name === 'ignoreblanklines' ||
      name === 'linebreak' ||
      name === 'skipheaders' ||
      name === 'columnshift' ||
      name === 'junkrecords' ||
      name === 'pagination'
    ) {
      value = e.target.checked;
    } else {
      value = e.target.value;
    }

    setFormField({
      ...formField,
      [name]: value,
    });
  };

  const handleResetForm = () => {
    setFormField(INITIALSTATE);
    setHeaderName([]);
    setFetchedHeader([]);
    setFilePathTouched(false);
    setTempHeader([]);
  };

  const compareTwoArrayOfObjects = (first_array_of_objects, second_array_of_objects) => {
    return (
      first_array_of_objects.length === second_array_of_objects.length &&
      first_array_of_objects.every((element_1) =>
        second_array_of_objects.some(
          (element_2) =>
            element_1.header === element_2.header &&
            element_1.tableAlias === element_2.tableAlias &&
            element_1.alias === element_2.alias &&
            element_1.checked === element_2.checked
        )
      )
    );
  };

  const handleFormsubmit = async (e) => {
    e.preventDefault();

    if (headerName.length === 0) {
      enqueueSnackbar('Please select atleast one column !', {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
      return;
    }

    const newHeaderName = [];

    headerName.forEach((item) => {
      newHeaderName.push({ ...item, tableAlias: formField.alias });
    });

    let equalArray;
    if (tempHeader.length > 0) {
      equalArray = compareTwoArrayOfObjects(tempHeader, newHeaderName);
    }

    const connectedNodes = [];

    if (!equalArray && tempHeader.length > 0) {
      edges?.forEach((el) => {
        if (el.source === nodeId) connectedNodes.push(el.target);
      });

      let count = 0;

      setNodes((nds) =>
        nds.map((node) => {
          if (count <= connectedNodes.length && node.id === connectedNodes[count]) {
            node.position.x += 0.1;
            count++;
          }

          return node;
        })
      );
    }

    sessionStorage.setItem('updatedNodes', JSON.stringify(connectedNodes));

    setHeaderName(newHeaderName);

    const getAllNodes = JSON.parse(sessionStorage.getItem('allNodes') || '[]');

    if (getAllNodes.length > 0) {
      const newFormData = getAllNodes.filter((el) => el.nodeId !== nodeId);
      sessionStorage.setItem('allNodes', JSON.stringify(newFormData));
    }

    let y_axis;

    nodes.forEach((el) => {
      if (nodeId === el.id) {
        y_axis = parseInt(el.position.x, 10);
        el.data.label = formField.alias;
      }
    });

    const sendFormData = {
      y_axis,
      nodeId,
      nodeName,
      formField,
      disabled: true,
      step_name: nodeName,
      headerName: newHeaderName,
      fetchedHeader,
      sampleMetaData: {
        columns,
        sampleRows,
      },
    };

    changeNodeName(nodes);

    setDisableForm(true);

    sessionStorage.setItem('node', JSON.stringify(nodes));
    sessionStorage.setItem('edges', JSON.stringify(edges));

    const fetchNodesData = JSON.parse(sessionStorage.getItem('allNodes') || '[]');
    fetchNodesData.push(sendFormData);

    sessionStorage.setItem('allNodes', JSON.stringify(fetchNodesData));

    const getElements = JSON.parse(sessionStorage.getItem('saved_node') || '[]');
    getElements.push(nodeId);
    sessionStorage.setItem('saved_node', JSON.stringify(getElements));
  };

  const handleEdit = (e) => {
    e.preventDefault();
    setDisableForm(false);

    store.forEach((node) => {
      if (node.nodeId === nodeId) {
        setTempHeader(headerName);
      }
    });

    const getAllNodes = JSON.parse(sessionStorage.getItem('allNodes'));

    getAllNodes.forEach((el) => {
      if (el.nodeId === nodeId) {
        el['disabled'] = false;
      }
    });

    sessionStorage.setItem('allNodes', JSON.stringify(getAllNodes));

    const getElements = JSON.parse(sessionStorage.getItem('saved_node'));

    const newSavedElement = getElements.filter((el) => el !== nodeId);

    sessionStorage.setItem('saved_node', JSON.stringify(newSavedElement));
  };

  const fetchFileHeader = async (dataType) => {

    if (!formField.connection_type) {
      enqueueSnackbar('Please select a connection type!', {
        variant: 'error',
      });
      return;
    }

    setLoadingBtn(true);

    if (formField.connection_type === 'default') {
      try {
        const data = {
          path: formField.path.split('/').slice(3).join('/'),
          workflow_id: workflow.workflow_id,
        };
        const response = await getCsvData(data);
        if (response.status === 200) {
          const header = [];

          const uniqueArray = [];
          const seen = {};

          response.data.map((item, index) => {
            if (!seen[item]) {
              seen[item] = index;
              uniqueArray.push(item);
            } else {
              const newItem = `${item}${index}`;
              seen[newItem] = 1;
              uniqueArray.push(newItem);
              uniqueArray[seen[item]] = `${item}${seen[item]}`;
            }
          });

          uniqueArray.forEach((el) => {
            header.push({
              header: el,
              alias: '',
              checked: true,
              tableAlias: '',
              cast_datatype: 'string',
              default_value: '',
              attribute_type: 'static',
            });
          });

          setFetchedHeader(header);
          setHeaderName(header);
          setTempHeader([]);
        }
      } catch (error) {
        setLoadingBtn(false);
        enqueueSnackbar('Path does not exist! Internal Server Error', { variant: 'error' });
      }
      
      const result = await getSampleData(formField.path, workflow.workflow_id, formField.secret_name, {
        sampleSize: 100,
      });

      if (result) {
        setColumns(result.columns);
        setSampleRows(result.sampleRows);

        setPreviewData((prev) => {
          const filtered = prev.filter((item) => item.nodeId !== nodeId);

          return [
            ...filtered,
            {
              nodeId,
              type: 'readcsv',
              columns: result.columns,
              sampleRows: result.sampleRows,
            },
          ];
        });
      }

      setLoadingBtn(false);
      return;
    }

    let data = {};
    if (dataType === DATA_TYPE_READ) {
      const pathArr = formField.path;
      const modifiedPath = pathArr.split('/').slice(3).join('/');

      console.log(modifiedPath);

      data = {
        path: modifiedPath,
        secretName: formField.secret_name,
      };
    }

    try {

      const result = await getSampleData(formField.path, workflow.workflow_id, formField.secret_name, {
        sampleSize: 100,
      });

      if (result) {
        setColumns(result.columns);
        setSampleRows(result.sampleRows);

        setPreviewData((prev) => {
          const filtered = prev.filter((item) => item.nodeId !== nodeId);

          return [
            ...filtered,
            {
              nodeId,
              type: 'readcsv',
              columns: result.columns,
              sampleRows: result.sampleRows,
            },
          ];
        });
      }

      const response = await getCsvData2(data);
      if (response.status === 200) {
        const header = [];

        const uniqueArray = [];
        const seen = {};

        response.data.map((item, index) => {
          if (!seen[item]) {
            seen[item] = index;
            uniqueArray.push(item);
          } else {
            const newItem = `${item}${index}`;
            seen[newItem] = 1;
            uniqueArray.push(newItem);
            uniqueArray[seen[item]] = `${item}${seen[item]}`;
          }
        });

        uniqueArray.forEach((el) => {
          header.push({
            header: el,
            alias: '',
            checked: true,
            tableAlias: '',
            cast_datatype: 'string',
            default_value: '',
            attribute_type: 'static',
          });
        });

        setFetchedHeader(header);
        setHeaderName(header);
        setTempHeader([]);
      }
    } catch (error) {
      enqueueSnackbar('Invalid path or expired secrets!', {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
    }
    setLoadingBtn(false);
  };

  useEffect(() => {
    if (isDataLoad) {
      setFormField({ ...formField });
    }
  }, [formField.file]);

  const handleChecked = (event) => {
    setFormField({ ...formField, sample_view: event.target.checked });
  };

  const fetchSecrets = async () => {
    setLoadingBtn(true);
    try {
      const response = await getSecretsList('s3'); // Adjust if needed
      setSecretsList(response.data);
    } catch (error) {
      setLoadingBtn(false);
      enqueueSnackbar('Secrets not found!', {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
    }
    setLoadingBtn(false);
  };

  const handleConnectionChange = (event) => {
    const connectionType = event.target.value; // Corrected variable name
    setFormField((prevFormField) => ({
      ...prevFormField,
      tablename: '',
      connection_type: connectionType,
      secret_name: '', // Reset secret when changing connection type
    }));

    setFetchedHeader([]);

    if (connectionType === 'other') {
      fetchSecrets(); // Fetch secrets when "Other" is selected
    }
  };

  const testSecret = async (secret) => {
    try {
      const payload = {
        secretName: secret,
        connectorType: 's3',
      };
      const response = await testS3SecretConnection(payload);
      if (response.status === 200) {
        return true;
      }
    } catch (error) {
      if (error.response.status === 403) {
        enqueueSnackbar(`You don't have Permission !!`, {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      } else if (error.response.status === 428) {
        enqueueSnackbar('Invalid or expired AWS credentials. Please update your secrets.', {
          variant: 'error',
          autoHideDuration: 4000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      } else {
        enqueueSnackbar('Test Connection Failed', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      }
      return false;
    }
  };

  const handleSecretSelection = async (secret) => {
    if (!testSecret(secret)) {
      return;
    }
    setFormField({
      ...formField,
      secret_name: secret, // Store selected secret
    });
    setFetchedHeader([]);
  };

  useEffect(() => {
    populateNodeData({
      workflow,
      nodeId,
      setFormField,
      setFetchedHeader,
      setHeaderName,
    });
  }, [workflow.copilotAddedPipeline, workflow.copilotOpen, nodeId]);


  const content = (
    <div style={{ margin: '20px' }}>
      <input type="hidden" value={nodeId} />
      <Box
        sx={{
          '& > :not(style)': { m: 2, width: '32ch' },
        }}
      >
        <InputField
          name="alias"
          label="Alias"
          value={formField.alias}
          onChange={handleInputChange}
          size="small"
          disabled={disableForm}
          required
        />
        <FormControlLabel
          control={
            <Checkbox size="small" checked={formField.sample_view} onChange={handleChecked} disabled={disableForm} />
          }
          label="Sample View"
          sx={{ pl: 1 }}
        />
      </Box>

      <Box
        component="form"
        sx={{
          '& > :not(style)': { m: 2, width: '30ch' },
        }}
        noValidate
        autoComplete="off"
      >
        <TextField
          id="outlined-basic"
          // select
          label="Format"
          variant="outlined"
          value="read_csv_aws"
          // onChange={handleInputChange}
          name="format"
          size="small"
          disabled
          required
          InputProps={{
            style: {
              fontFamily: "'EB Garamond', serif ",
              fontWeight: 600,
            },
          }}
          InputLabelProps={{ style: { fontFamily: "'EB Garamond', serif " } }}
        />

        <FormControl size="small">
          <InputLabel id="demo-select-small-label">Connection Type</InputLabel>
          {AWS_CONFIG_TYPE ? (
            <>
              <Select
                labelId="connection-type-label"
                id="connection-type-select"
                value={formField.connection_type}
                label="Connection Type"
                disabled={disableForm}
                required
                onChange={handleConnectionChange}
              >
                <MenuItem value="default">Default</MenuItem>
                <MenuItem value="other">Other</MenuItem>
              </Select>
            </>
          ) : (
            <Select
              labelId="connection-type-label"
              id="connection-type-select"
              value={formField.connection_type}
              label="Connection Type"
              disabled={disableForm}
              required
              onChange={handleConnectionChange}
            >
              <MenuItem value="other">Other</MenuItem>
            </Select>
          )}
        </FormControl>

        {formField.connection_type === 'other' && (
          <FormControl size="small">
            <InputLabel id="secrets-list-label">Select Connection</InputLabel>
            <Select
              labelId="secrets-list-label"
              id="secrets-list-select"
              value={formField.secret_name}
              label="Select connection"
              required
              disabled={disableForm}
              onChange={(e) => handleSecretSelection(e.target.value)}
            >
              {secretsList.length > 0 ? (
                secretsList.map((secret, index) => (
                  <MenuItem key={index} value={secret}>
                    {secret}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No Connection available</MenuItem>
              )}
            </Select>
          </FormControl>
        )}
      </Box>

      <Box
        component="form"
        sx={{
          '& > :not(style)': { m: 2, width: '32ch' },
        }}
        noValidate
        autoComplete="off"
      >
        {formField.format === 'delimited' && (
          <>
            <InputField
              name="path"
              label="File Path"
              value={formField.path}
              onChange={handleInputChange}
              size="small"
              disabled={disableForm}
              required
            />

            <Button
              style={{ width: '100px' }}
              variant="outlined"
              onClick={() => fetchFileHeader(DATA_TYPE_READ)}
              disabled={disableForm}
              className="outlined-button-color"
            >
              Fetch
            </Button>
          </>
        )}
        {formField.format === 'read_csv_aws' && (
          <>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              {formField.dataTypeRead === DATA_TYPE_READ && (
                <>
                  <Grid container spacing={1} sx={{ width: '200%' }}>
                    <>
                      {formField.pathTypeFile === 'filepath' && (
                        <>
                          <Grid item xs={10}>
                            <FormControl
                              sx={{
                                width: '100%',
                              }}
                            >
                              <TextField
                                id="filepath"
                                name="path"
                                label="File Path"
                                value={formField.path}
                                onChange={handleInputChange}
                                onBlur={() => setFilePathTouched(true)}
                                size="small"
                                disabled={disableForm}
                                required
                                error={filePathTouched && Boolean(errors.filepath)}
                                helperText={filePathTouched ? errors.filepath : ''}
                              />
                            </FormControl>
                          </Grid>
                          <Grid item xs={2}>
                            <Button
                              style={{ width: '100px' }}
                              variant="outlined"
                              onClick={() => {
                                fetchFileHeader(DATA_TYPE_READ);
                              }}
                              disabled={disableForm || errors.filepath}
                              className="outlined-button-color"
                            >
                              Fetch
                            </Button>
                          </Grid>
                        </>
                      )}
                    </>
                  </Grid>
                </>
              )}
            </div>
          </>
        )}
      </Box>

      {loadingBtn && (
        <Box>
          <LoadingIcon />
        </Box>
      )}

      {!loadingBtn && fetchedHeader.length > 0 && (
        <TableContainer sx={{ maxHeight: 300 }}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell>
                  <Checkbox
                    color="primary"
                    checked={fetchedHeader.length === headerName.length}
                    onChange={handleSelectAllClick}
                    disabled={disableForm}
                  />
                  Select Columns
                </TableCell>
                <TableCell>Columns</TableCell>
                <TableCell>Datatype</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {fetchedHeader.map((row, i) => {
                const isItemSelected = isSelected(row.header);
                return (
                  <TableRow
                    hover
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={i}
                    selected={isItemSelected}
                  >
                    <TableCell>
                      <Checkbox
                        checked={isItemSelected}
                        disabled={disableForm}
                        onChange={(event) =>
                          handleHeaderChange({
                            header: row.header,
                            alias: '',
                            checked: event.target.checked,
                            cast_datatype: row.cast_datatype ? row.cast_datatype : 'string',
                            default_value: row.default_value,
                            attribute_type: row.attribute_type,
                          })
                        }
                        inputProps={{ 'aria-label': 'controlled' }}
                      />
                    </TableCell>
                    <TableCell>{row.header}</TableCell>

                    <TableCell>
                      <TextField
                        id="standard-select-currency"
                        select
                        label="Cast Datatype"
                        name="cast_datatype"
                        disabled={disableForm}
                        value={row.cast_datatype ? row.cast_datatype : 'string'}
                        onChange={(event) =>
                          handleHeaderChange({
                            header: row.header,
                            alias: row.alias,
                            checked: true,
                            cast_datatype: event.target.value,
                            default_value: row.default_value,
                            attribute_type: row.attribute_type,
                          })
                        }
                        style={{ width: '100%' }}
                        size="small"
                      >
                        <MenuItem value="string">String</MenuItem>
                      </TextField>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );

  return dataModel ? (
    content
  ) : (
    <div>
      <Dialog fullScreen open={open} TransitionComponent={Transition} style={{ width: '70%', marginLeft: '30%' }}>
        <form autoComplete="off" onSubmit={handleFormsubmit}>
          <AppBar sx={{ position: 'relative', backgroundColor: '#fff' }}>
            <Toolbar>
              <IconButton edge="start" onClick={handleClose} aria-label="close" sx={{ color: '#00043C' }}>
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1, color: '#00043C' }} variant="h6" component="div">
                {/* {nodeName} */}
                Read CSV AWS
              </Typography>
              <ButtonGroup variant="contained" aria-label="outlined primary button group">
                <Button
                  size="small"
                  variant="outlined"
                  onClick={handleResetForm}
                  disabled={disableForm}
                  className="outlined-button-color"
                >
                  Clear
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  disabled={!disableForm}
                  className="outlined-button-color"
                  onClick={handleEdit}
                >
                  Edit
                </Button>
                <Button type="submit" size="small" variant="contained" disabled={disableForm} className="button-color">
                  Submit
                </Button>
              </ButtonGroup>
            </Toolbar>
          </AppBar>
          {content}
        </form>
      </Dialog>
    </div>
  );
};

export default memo(NodeModalReadCSVAws);
